import { Component, OnInit } from '@angular/core';
import { LibraryService, Dropobj } from '../services/library.service';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-libperiodicals',
  templateUrl: './libperiodicals.component.html',
  styleUrls: ['./libperiodicals.component.scss'],
  providers:[LibraryService]
})
export class LibperiodicalsComponent implements OnInit {

  arrfreq=[];
  arrpubl=[];
  arrsubs=[];
  arrcat=[];
  arrpbtype=[];
  arrprvrtype=[{name:'Print'},{name:'online'},{name:'Both'}];
  arrmop=[{name:'DD'},{name:'CHEQUE'},{name:'ONLINE'}];
  moplbl='DD No.';
  
  arrpdkls=[];
  laguages=[];
  sources=[];
  suppliers=[];
  currency=[];
  arrsubrpns=[];
  arrrec=[];
  prmodel:any={};
  
  sbrmodel:any={};
  recrmodel:any={};
  objvisitcnt:any={};
  objpercnts:any={};
  oprtag='';
  objselrec:any={};
  arrstatus=[{name:'Pending'},{name:'Received'}];

  arrstatus1=[{name:'All'},{name:'Pending'},{name:'Received'}];
  defstat='All';
  
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  tab=1;
  objselper:any={};
  fserdt:any;
  fserdt4:any;
  clsdate:any=[];
  showload='No';
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
        position: 'left',
      },
  };
  doughnutChartLabels: Label[] ;
  //= ['BMW', 'Ford', 'Tesla'];
  doughnutChartData: MultiDataSet ;
  // = [
  //   [55, 25, 20]
  // ];
  doughnutChartType: ChartType = 'doughnut';
  public doughnutChartColors: Color[] = [
    {backgroundColor:["#9E120E","#FF5800","#FFB414","#BBB414","#8BE212","#FF3333","#FFFF66","#5EE8C6","#5EC2E8","#AF5EE8","#5EE8A1","#9505F9","#F9A005","#F90595","#BC3210","#A5E2ED"]},
    // {backgroundColor:["#9E120E","#FF5800","#FFB414"]},
    // {backgroundColor:["#9E120E","#FF5800","#FFB414"]}
  ];
  constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal) {
this.setfirstdate();
this.setlastdate();

   }

  ngOnInit(): void {
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop'
    }
//this.getlibvisitordashcounts();
this.getperiodicaldashcounts();
    this.getlibmperiodical('selwithsub');
  this.getgenmasters();
  this.getlibmfrequency();
  this.getlibmpdcat();
  this.getlibmpdtype();
  this.getlibpublisher();
  this.getlibsubjects();
  this.getlibsource();
  this.getlibsupplier();
  this.getcurrecy();
  
  }


  exportperiodical(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.liservice.callurl+"export/expperiodicals.php?clcd="+clcd+"&aycd="+aycd;
  
     window.open(url,'','_blank');
   }


  booksoverview()
{
  
  this.liservice.Getdashboarddata('bookscollection')
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    this.clsdate=resultArray;

    //this.mutitest();
   // this.dataSource = new MatTableDataSource(resultArray);
   var arr = []
   var labelarr=[];


   for ( var i = 0; i < resultArray.length ; i++) {
    //console.log('multiarray -i',JSON.stringify(i));
     
          
    labelarr.push(resultArray[i].bookcategory);
         
    arr.push(parseInt( this.clsdate[i].cnt));    
         
  }
    
   
    this.doughnutChartLabels = labelarr;
   this.doughnutChartData = arr;
   
   console.log("doughnutChartData ", this.doughnutChartData);
    },
   error => console.log("Error :: " + error)
)
}
onchangemop(e)
{
  debugger
  if(e=='DD')
  {
    this.moplbl='DD No.';
  }
  else if(e=='CHEQUE')
  {
    this.moplbl='CHEQUE No.';
  }

  else if(e=='ONLINE')
  {
    this.moplbl='REF No.';
  }

}
  setfirstdate() {
    this.liservice.getmontfirstdate()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            this.fserdt = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  setlastdate() {
    this.liservice.getmontlastdate()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            this.fserdt4 = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  getlibsource() {
    this.liservice.getlibsource()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            this.sources = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  getlibmperiodical(oprtype) {
    this.liservice.getlibmperiodical(oprtype)
        .subscribe(
        resultArray => {
            console.log('periodical-result', resultArray);
            this.arrpdkls = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }


  getlibtsubscriptionh(oprtype) {
    this.liservice.getlibtsubscriptionh(oprtype)
        .subscribe(
        resultArray => {
            console.log('periodical-result', resultArray);
            this.arrsubrpns = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  dellibtsubscriptionh(sbid) {
    if(confirm('Are you  sure,you want to delete? '))
    {
    this.liservice.dellibtsubscriptionh(sbid)
        .subscribe(
        resultArray => {
            console.log('periodical-result', resultArray);
            //this.arrsubrpns = resultArray;
            alert(resultArray.message);
            this.subclick();
            
        },
        error => console.log("Error :: " + error)
        )
      }
  }

  dellibtsubrecevables(srid) {
    if(confirm('Are you  sure,you want to delete? '))
    {
    this.liservice.dellibtsubreceivable(srid)
        .subscribe(
        resultArray => {
            console.log('periodical-result', resultArray);
            //this.arrsubrpns = resultArray;
            alert(resultArray.message);
            this.recclick('All');
            
        },
        error => console.log("Error :: " + error)
        )
      }
  }


  getlibtsubreceivable(oprtype,status) {
    this.liservice.getlibtsubreceivable(oprtype,this.fserdt,this.fserdt4,status)
        .subscribe(
        resultArray => {
            console.log('periodical-result', resultArray);
            this.arrrec = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }
  getlibmfrequency() {
    this.liservice.getlibmfrequency()
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            this.arrfreq = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  getlibmpdcat() {
    this.liservice.getlibmpdcat()
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            this.arrcat = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }


  
  getlibmpdtype() {
    this.liservice.getlibmpdtype()
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            this.arrpbtype = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  
  getlibsubjects() {
    this.liservice.getlibdepartment()
        .subscribe(
        resultArray => {
            console.log('getlibsubjects', resultArray);
            this.arrsubs = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  getlibpublisher() {
    this.liservice.getlibpublisher("selforper")
        .subscribe(
        resultArray => {
            console.log('getlibpublisher', resultArray);
            this.arrpubl = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }
  getcurrecy() {
    //de
    var resuarr=[];
  return  this.liservice.getgenmasters('Currency')
        .subscribe(
        resultArray => {
            console.log('getgenmasters', resultArray);
           
            this.currency = resultArray;
            if (resultArray.length>0)
            {
            this.sbrmodel.currencyid=resultArray[0].id;
            }
            else
            {
              this.sbrmodel.currencyid='0';
            }
            }
          
           
        ,
        error => console.log("Error :: " + error)
        )
       
  }

  getlibsupplier() {
    this.liservice.getlibsupplier()
        .subscribe(
        resultArray => {
            console.log('getlibsupplier', resultArray);
            this.suppliers = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  getperiodicaldashcounts() {
    this.liservice.getperiodicaldashcounts()
        .subscribe(
        resultArray => {
            console.log('dash', resultArray);
            this.objpercnts = resultArray[0];
           
        },
        error => console.log("Error :: " + error)
        )
  }

  
  getgenmasters() {
    //de
    var resuarr=[];
  return  this.liservice.getgenmasters('Language')
        .subscribe(
        resultArray => {
            console.log('getgenmasters', resultArray);
           
            this.laguages = resultArray;
            if (resultArray.length>0)
            {
            this.prmodel.lgid=resultArray[0].id;
            }
            else
            {
              this.prmodel.lgid='0';
            }
            }
          
           
        ,
        error => console.log("Error :: " + error)
        )
       
  }


  opendialog(content,formdata,cmd) {
    console.log("formdata",formdata);
   
    
    if(cmd=='insert')
    {
      this.prmodel={};
     
      if (this.laguages.length>0)
      {
      this.prmodel.lgid=this.laguages[0].id;
      }
      else
      {
        this.prmodel.lgid='0';
      }
  
     
     
      this.prmodel.pdid='0';
      this.prmodel.pdcd='';
      this.prmodel.pdtitle='';
      this.prmodel.fqid='1';
      this.prmodel.pdtypeid='1';
      this.prmodel.pdcatid='1';
      this.prmodel.classno='';
      this.prmodel.callno='1';
      //this.booksmodel.currencyid=1;
      this.prmodel.subid='1';
      this.prmodel.issn='';
      this.prmodel.editor='';
      this.prmodel.pubid='1';
      this.prmodel.pubplace='';
      this.prmodel.website='';
      this.prmodel.email='';
      this.prmodel.phone='';
      this.prmodel.pdvrtype='Print';
      this.prmodel.oprtype='insert';
     
    }
    else if (cmd=='update')
    {
      this.prmodel=formdata;
      this.prmodel.oprtype='update'
  
    }
    
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           
       });
      
    
  }


  opensubdialog(content,formdata,cmd,objbook,opr) {
    debugger
    console.log("formdata",formdata);
    console.log("objbook",objbook);
  this.objselper=objbook;
  this.oprtag=opr;
    
    if(cmd=='insert')
    {
      this.sbrmodel={};
     
      if (this.currency.length>0)
      {
      this.sbrmodel.currencyid=this.currency[0].id;
      }
      else
      {
        this.sbrmodel.currencyid='0';
      }
  
     this.sbrmodel.mop='DD';
      this.sbrmodel.sbid=objbook.subid;
      this.sbrmodel.pdid=objbook.pdid;
      this.sbrmodel.sbdt=this.liservice.getdatetoday();
      this.sbrmodel.exdt=this.liservice.getdatetoday();
      this.sbrmodel.ptdt=this.liservice.getdatetoday();
      this.sbrmodel.pono='';
      this.sbrmodel.podt=this.liservice.getdatetoday();
      this.sbrmodel.supid='1';
      this.sbrmodel.copies='1';
      //this.booksmodel.currencyid=1;
      this.sbrmodel.billno='';
      this.sbrmodel.billdt=this.liservice.getdatetoday();
      //this.sbrmodel.currencyid='';
      this.sbrmodel.mrp='0';
      this.sbrmodel.prate='0';
      this.sbrmodel.disc='0';
      this.sbrmodel.netamt='0';
      this.sbrmodel.deptid='1';
      this.sbrmodel.srcid='1';
      this.sbrmodel.oprtype='insert';
      this.sbrmodel.oprtag=this.oprtag;
      this.sbrmodel.refno='';
      this.sbrmodel.sbno='';
     
    }
    else if (cmd=='update'|| cmd=='detview')
    {
      this.sbrmodel=formdata;
      this.sbrmodel.oprtype='update'
      this.sbrmodel.oprtag=this.oprtag;
  
    }
    
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           
       });
      
    
  }


  openrecdialog(content,formdata,cmd) {
    console.log("formdata",formdata);
  this.objselrec=formdata;
    
    if(cmd=='insert')
    {
      // this.recmodel={};
     
      // if (this.currency.length>0)
      // {
      // this.sbrmodel.currencyid=this.currency[0].id;
      // }
      // else
      // {
      //   this.sbrmodel.currencyid='0';
      // }
  
     
      // this.sbrmodel.sbid='0';
      // this.sbrmodel.pdid='1';
      // this.sbrmodel.sbdt=this.liservice.getdatetoday();
      // this.sbrmodel.exdt=this.liservice.getdatetoday();
      // this.sbrmodel.ptdt=this.liservice.getdatetoday();
      // this.sbrmodel.pono='';
      // this.sbrmodel.podt=this.liservice.getdatetoday();
      // this.sbrmodel.supid='1';
      // this.sbrmodel.copies='1';
      // //this.booksmodel.currencyid=1;
      // this.sbrmodel.billno='';
      // this.sbrmodel.billdt=this.liservice.getdatetoday();
      // //this.sbrmodel.currencyid='';
      // this.sbrmodel.mrp='0';
      // this.sbrmodel.prate='0';
      // this.sbrmodel.disc='0';
      // this.sbrmodel.netamt='0';
      // this.sbrmodel.deptid='1';
      // this.sbrmodel.srcid='1';
      // this.sbrmodel.oprtype='insert';
     
    }
    else if (cmd=='update')
    {
      this.recrmodel=formdata;
      this.recrmodel.oprtype='update'
  
    }
    
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           
       });
      
    
  }
  genaratereceivables(pdid,sbid,tag)
  {
    if(tag=='G')
    {
 var c=  confirm('Are you sure you want to generate receivables..?')
 if (c==true)
 {
   this.showload="Yes";
      this.liservice.genaratereceivables(pdid,sbid)
    .subscribe(
    resultArray => {
        console.log('getgenmasters', resultArray);
       
       alert(resultArray.message);
       this.showload="No";
      
    }
    ,
    error =>{ console.log("Error :: " + error);

    alert('Error');
    this.showload="No";
  }
    )
 }
}
else if(tag=='R')
{

  this.showload="Yes";
      this.liservice.genaratereceivables(pdid,sbid)
    .subscribe(
    resultArray => {
        console.log('getgenmasters', resultArray);
       
       alert(resultArray.message);
       this.showload="No";
      
    }
    ,
    error =>{ console.log("Error :: " + error);

    alert('Error');
    this.showload="No";
  }
    ) 
}
  }

checkndgen(pdid,sbid)
{
debugger
    this.liservice.checklibtsubreceivable(pdid,sbid)
  .subscribe(
  resultArray => {
      console.log('getgenmasters', resultArray);
     
     //alert(resultArray.message);
    // this.showload="No";

    if(parseInt( resultArray.rcnt)>0)
    {
if(confirm("Receivable already generate, do you wan't to regenerate? \nNote:Previous data will be wiped out for this subscription."))
{
  this.genaratereceivables(pdid,sbid,'R');

}

    }
    else
    {

      this.genaratereceivables(pdid,sbid,'G');
    }
    
  }
  ,
  error =>{ console.log("Error :: " + error);

  alert('Error');
  //this.showload="No";
}
  )

}
  SaveDetails()
  {
    console.log('catsave',this.prmodel);
    this.liservice.Savelibmperiodical(this.prmodel)
        .subscribe(
        result => {
            console.log('SavesourceDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibmperiodical('selwithsub');
             // this.get();
            }
         else  {

           }
        },
        error =>{ alert('Error While saving...');}
        )

  }

  savelibtsubscriptionh()
  {
    console.log('catsave',this.sbrmodel);
    this.liservice.savelibtsubscriptionh(this.sbrmodel)
        .subscribe(
        result => {
            console.log('SavesourceDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              if(this.sbrmodel.oprtype=='insert')
              {
              this.getlibmperiodical('selwithsub');
              }
              else if(this.sbrmodel.oprtype=='update')
              {
                this.getlibtsubscriptionh('select');
              }
             // this.get();
            }
         else  {

           }
        },
        error =>{ alert('Error While saving...');}
        )

  }



  savelibtsubreceivable()
  {
    console.log('catsave',this.recrmodel);
    this.liservice.savelibtsubreceivable(this.recrmodel)
        .subscribe(
        result => {
            console.log('SavesourceDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibtsubreceivable('selbtdate',this.defstat);
             // this.get();
            }
         else  {

           }
        },
        error =>{ alert('Error While saving...');}
        )

  }
  perclick()
  {
    this.getlibmperiodical('selwithsub');

  }
  subclick()
  {
    this.getlibtsubscriptionh('select');

  }

  recclick(status)
  {
    debugger
    this.getlibtsubreceivable('selbtdate',status);

  }

  pendingclick(status)
  {
    this.getlibtsubreceivable('selpending',status);

  }
}
